// extracted by mini-css-extract-plugin
export default {"price":"s8-z","priceRow":"t8-z","onSale":"u8-z","msrpLabelPrice":"v8-z","msrpLabel":"w8-z","originalPrice":"x8-z","percentOff":"y8-z"};